import axios from 'axios'; // eslint-disable-line no-restricted-imports
import type { AuthRedirectConfig, PostHelperConfig } from './types';

// Get CSRF token from cookie
function getCookie(name: string): string | null {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default class Request {
  static redirectToLoginIfUnauthorized(error: any, config?: AuthRedirectConfig): void {
    if (error?.status === 401 || error?.status === 403) {
      const currentUrl = window.location.href;

      let nextUrl = currentUrl;

      if (config?.saveForLater) {
        const url = new URL(currentUrl);

        url.searchParams.set('post_auth_action', 'save_content');
        url.searchParams.set('post_auth_payload', JSON.stringify(config.saveForLater));

        nextUrl = url.toString();
      }

      const redirectUrl = `/auth/endpoint/login/result?next=${encodeURIComponent(nextUrl)}`;
      window.location.href = `/auth/login?next=${encodeURIComponent(redirectUrl)}`;
    }
  }

  static async getHelper<T>(url: string, params: any = {}): Promise<T> {
    return axios.get(url, params).then(
      (success) => Promise.resolve(success as T),
      (error) => {
        if (params?.signal?.aborted) return Promise.reject(error);
        if (error.response) return Promise.reject(error.response);

        return Promise.reject(error);
      }
    );
  }

  static async postHelper<T>(url: string, data: unknown = {}, config: { signal?: AbortSignal; headers?: Record<string, string>;[key: string]: unknown } = {}): Promise<T> {
    const csrfToken = getCookie('sj_csrftoken');
    const headers = {
      'Content-Type': 'application/json',
      ...(config.headers || {}),
      ...(csrfToken && { 'X-CSRFTOKEN': csrfToken })
    };

    const configWithCsrf = {
      ...config,
      headers
    };

    return axios.post(url, data, configWithCsrf).then(
      (success) => Promise.resolve(success as T),
      (error) => {
        if (configWithCsrf?.signal?.aborted) return Promise.reject(error);
        if (error.response) return Promise.reject(error.response);

        return Promise.reject(error);
      }
    );
  }

  static async postHelperWithAuthRedirect<T>(url: string, data: unknown = {}, config: PostHelperConfig = {}): Promise<T> {
    return this.postHelper<T>(url, data, config).catch((error) => {
      this.redirectToLoginIfUnauthorized(error, { saveForLater: config.saveForLater });

      throw error;
    });
  }
}
